import React from 'react'
import classNames from 'classnames'

import { WithStyles, createStyles, withStyles, Theme } from '@material-ui/core/styles'

interface Props extends React.HTMLProps<HTMLDivElement> {
}

const styles = (theme: Theme) => createStyles({
  root: {
    maxWidth: theme.breakpoints.values.sm,
    margin: '0 auto',
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const CenteredContent: React.SFC<InjectedProps> = ({ className, classes, ...props }) => (
  <div className={classNames(classes.root, className)} {...props} />
)

export default withStyles(styles)(CenteredContent)
